module.exports = __webpack_public_path__ + "assets/img/saules-moduliu-isdestymas.3455f1fa.jpg";